import { useCallback } from "react";
import { useCardModal } from "modules/cards/stores/useCardsStore";
import { FinishEnum, GameCard } from "modules/cards/model/card";
import { usePricingOverride } from "modules/common/components/Providers/PricingProvider";
import type { GameId } from "modules/common/model/models";

export function useCardDetailsModal() {
  const { openModal, openModalByDataId } = useCardModal();
  const pricing = usePricingOverride();

  const handleOpenCardDetails = useCallback(
    (card: GameCard, finish?: FinishEnum) => {
      openModal(card, pricing, finish);
    },
    [openModal, pricing]
  );

  const handleOpenCardDetailsByDataId = useCallback(
    (dataId: string, game: GameId, finish?: FinishEnum) => {
      // We'll open the modal immediately and show loading state
      openModalByDataId(dataId, game, finish, pricing);
    },
    [openModalByDataId, pricing]
  );

  return { handleOpenCardDetails, handleOpenCardDetailsByDataId };
}
